import React, { useState } from "react";
import arrowup from './img/arrowup.png';
import arrowdown from './img/arrowdown.png';
import "./FAQ.css";

function FAQ() {

  // which question is open
  const [open, setOpen] = useState(null);

  // show more or not
  const [more, setMore] = useState(false);

  //  data
  const data = [
    { q: "What is a Cyber Security Course and how can it help my career?", a: "A Cyber Security Course teaches you how to protect systems, networks, and data from cyber threats. It helps you build job-ready skills for roles like ethical hacker, security analyst, and IT security specialist." },
    { q: "Can beginners join a Cyber Security Course without technical knowledge?", a: "Yes, beginners can easily join a Cyber Security Course. The training starts from basic concepts like networking and Linux, making it suitable for students and non-technical learners." },
    { q: "Is Cyber Security a good career option in today’s job market?", a: "Cyber security is one of the fastest-growing careers globally. With increasing cyber threats, companies are actively hiring skilled professionals, making it a stable and high-demand career option." },
    { q: "What skills will I learn in a Cyber Security Course?", a: "In a Cyber Security Course, you will learn networking (CCNA basics), Linux, ethical hacking, vulnerability assessment, penetration testing, and security tools used in real-world environments." },
     { q: "Do I need coding knowledge to start learning cyber security?", a: "No, coding is not mandatory to start a Cyber Security Course. Basic programming knowledge can be helpful later, but most courses begin with fundamentals." },
      { q: "What are the job opportunities after completing a Cyber Security Course?", a: "After completing a Cyber Security Course, you can work as an Ethical Hacker, Cyber Security Analyst, SOC Analyst, Penetration Tester, or Network Security Engineer." },
       { q: "Does the course include ethical hacking and practical training?", a: "Yes, a professional Cyber Security Course includes ethical hacking along with hands-on practical training, live labs, and real-world attack simulations." },
        { q: "Will I get hands-on experience with real cyber security tools?", a: "Yes, you will get practical experience using tools like Kali Linux, Nmap, Wireshark, and Metasploit during the Cyber Security Course." },
         { q: "Do you provide certification and job placement support?", a: "Yes, the Cyber Security Course includes certification guidance (such as CCNA and ethical hacking paths) along with resume building, interview preparation, and job assistance." },
          { q: "How long does it take to become a cyber security professional?", a: "It typically takes 6 months to 1 year to become job-ready through a structured Cyber Security Course, depending on your learning pace and practice level." }

  ];

  return (
    <div className="box">

      <h2>Frequently Asked Questions</h2>

      {/* show 2 or all */}
      {(more ? data : data.slice(0, 2)).map((item, i) => (

        <div className="item" key={i}>

          {/* question */}
          <div className="q" onClick={() => setOpen(open === i ? null : i)}>
            {item.q}
            <span>{open === i ? "-" : "+"}</span>
          </div>

          {/* answer */}
          {open === i && <p className="a">{item.a}</p>}

        </div>
      ))}

{/* button */}
<div className="faq-btn">
  <button onClick={() => setMore(!more)} className="btn">

    {more ? (
      <>
        View Less
        <img src={arrowup} alt="down" className="arrow-icon" />
      </>
    ) : (
      <>
        View More
        <img src={arrowdown} alt="up" className="arrow-icon" />
      </>
    )}

  </button>
</div>
    </div>
  );
}

export default FAQ;
